const bridgePlugin = {
  install(app) {
    const isAndroid = /Android/i.test(navigator.userAgent);
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);


    /**테스트 예제들 작성  web용 테스트는 삭제 해야함 */
    const $bridge = {
      _callbacks: {}, // 콜백 함수 보관용
      _callbackId: 0, // 콜백 고유 ID 생성을 위한 카운터
      
      _currentKeyPadCbld : null, // 키패드용 전역 콜백 ID


      getPlatform() {
        if (isAndroid) return 'ANDROID';
        if (isIOS) return 'IOS';
        return 'WEB';
      },


    _postMessage(message, reject){
      const platform = this.getPlatform();

      if(platform ==='ANDROID' &&  window.AndroidBridge){
        window.AndroidBridge.postMessage(JSON.stringify(message));
      }else if(platform==='IOS' && window.webkit?.messageHandlers?.iOSBridge){
        window.webkit.messageHandlers.iOSBridge.postMessage(message);
      }else{
        console.log("[WEB] 네이티브 브릿지 호출(웹 테스트용) ", message)
        if(reject) reject(new Error("No native bridge"))
      }
    },

    //setIssueUser, setSimpleLogin, getUuid, loginInfo, verInfo, bioLoginWeb,
    //범용 네이티브 호출(Promise 기반, 1회성 응답용)
    //사용법 $bridge.callNative('getUserData',{user:123}).then((response)=>{console.log(response)})
    callNative(action, data={}){
      console.log(action + "요청함!!")
      return new Promise((resolve, reject)=>{
        const callbackId = 'cb_'+ Math.random().toString(36).substr(2,9);

        console.log("callNative")
        //웹에서 리턴값을 받기 위한 임시 전역 콜백 함수 생성
        window[callbackId] = (responseData)=>{
          resolve(responseData);
          delete window[callbackId]; //메모리 누수 방지를 위해 콜백 삭제
        };

        const message ={
          action : action,
          data : data,
          callbackId : callbackId
        };

        this._postMessage(message, reject);
      })
    },

    // 키보드 호출(여러번 응답 받아야함  )
    // 사용법 $bridge.openKeypad((key)=>{..}){}
    // 사용법 2026-05-21 $bridge.openKeypad();
    //2026-05-21 해당 메소드  키보드는 콜백 받을 수 없다함
    openKeyPad(){
      // console.log("openKeyPad")
      //이전에 열려있던 키패드 콜백이 있으면 제거
      // if(this._currentKeyPadCbld){
      //   delete window[this._currentKeyPadCbld]
      // }

      // const callbackId = 'cb_'+ Math.random().toString(36).substr(2,9);
      const callbackId = 'not_001';
      // this._currentKeyPadCbld = callbackId;

      //키패드는 여러번 눌림으로 바로 삭제하지 않음
      //2026-05-21 콜백 형식이 아닌 키보드가 메소드 호출하는 형식으로 변경
      
      // window[callbackId]= (text)=>{
      //   if(typeof callback ==='function'){
      //     callback(text)
      //   }
      // };


      const message={
        action: 'openKeypad',
        data:{},
        callbackId : callbackId
      }


      this._postMessage(message)
    },

  
    //키패드 닫기
    closeKeypad(){
      //키보드 닫을때 콜백함수 확인

      const callbackId = 'not_001';

      // if(this._currentKeyPadCbld){
      //   delete window[this._currentKeyPadCbld];
      //   this._currentKeyPadCbld = null;
      // }

      const message ={
        action : 'closeKeypad',
        data : {},
        callbackId :callbackId
      };
      this._postMessage(message);
    },
    retryKeypad(){
      //키보드 닫을때 콜백함수 확인

      const callbackId = 'not_001';

      // if(this._currentKeyPadCbld){
      //   delete window[this._currentKeyPadCbld];
      //   this._currentKeyPadCbld = null;
      // }

      const message ={
        action : 'retryKeypad',
        data : {},
        callbackId :callbackId
      };
      this._postMessage(message);
    },
    startSmsListener(){
      
      const callbackId = 'not_001';

      const message ={
        action : 'startSmsListener',
        data : {},
        callbackId :callbackId
      };
      this._postMessage(message);
    },
    stopSmsListener(){
      
      const callbackId = 'not_001';

      const message ={
        action : 'stopSmsListener',
        data : {},
        callbackId :callbackId
      };
      this._postMessage(message);
    },
    callNumber(params = {}){
      
      const callbackId = 'not_001';

      const message ={
        action : 'callNumber',
        data : params,
        callbackId :callbackId
      };
      this._postMessage(message);
    },
    initKeypad(params = {}){
      
      const callbackId = 'not_001';

      const message ={
        action : 'initKeypad',
        data : params,
        callbackId :callbackId
      };
      this._postMessage(message);
    },
    sessionInfo(params={}){
       const callbackId = 'not_001';

      const message ={
        action : 'sessionInfo',
        data : params,
        callbackId :callbackId
      };
      this._postMessage(message);
    },

    //모바일카드를 발급후 네이티브로 정보를 넘겨준다
    //받았다고 응답이 필요한 경우 callNative를 사용하여 응답을 받아야한다.
    // setIssueUser(params = {}) {
    //   const callbackId = 'NOT_001';

    //   const message ={
    //     action : 'setIssueUser',
    //     data : params ,
    //     callbackId :callbackId
    //   };


    //   this._postMessage(message);
    // },

    //결과 리턴 받아야함
    // setSimpleLogin(params = {}) {
    //   const callbackId = 'NOT_001';

    //   const message ={
    //     action : 'setSimpleLogin',
    //     data : params ,
    //     callbackId :callbackId
    //   };

    //   this._postMessage(message);
    // },
    //리턴 받아야함
    // getUuid(){
    //   const callbackId = 'NOT_001';

    //   const message ={
    //     action : 'getUuid',
    //     data : {} ,
    //     callbackId :callbackId
    //   };

    //   this._postMessage(message);
    // },

    closeWebView() {
      console.log("웹뷰닫기 요청!!")
      const callbackId = 'not_001';

      const message ={
        action : 'closeWebView',
        data : {} ,
        callbackId :callbackId
      };

      this._postMessage(message);
    },
    closeApp() {
      console.log("앱종료 요청!!")
      const callbackId = 'not_001';

      const message ={
        action : 'closeApp',
        data : {} ,
        callbackId :callbackId
      };

      this._postMessage(message);
    },
    bioLogin(){
      console.log("생체로그인 요청!!")
      const callbackId = 'not_001';
      const message ={
        action : 'bioLogin',
        data: {},
        callbackId: callbackId
      };
      this._postMessage(message)
    },
    login(params = {}){
      console.log("간편비밀번호 로그인 요청!!!")
      const callbackId = 'not_001';
      const message ={
        action : 'login',
        data: params,
        callbackId: callbackId
      };
      this._postMessage(message)
    },
    openLicense() {
      console.log("라이선스 화면 요청!!")
      const callbackId = 'not_001';

      const message ={
        action : 'openLicense',
        data : {} ,
        callbackId :callbackId
      };

      this._postMessage(message);
    },



    };





    app.config.globalProperties.$bridge = $bridge;
    app.provide('$bridge', $bridge);
    window.$bridge = $bridge;
  }
};

export default bridgePlugin;
